import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function EguCustomerInfo ( props ) {

    return <BasicCrudScreenType id="MomSysUdtCompany" table="MomSysUdtCompany" view="MomSysVwCompany" />;

}

export default EguCustomerInfo;
